/**
 * Environment Variable Validator
 * 
 * This utility validates that all required environment variables are present
 * and properly formatted before the application starts.
 */

/**
 * Validates all required environment variables
 * @returns {boolean} - Whether all required variables are valid
 */
export const validateEnvironmentVariables = () => {
  const requiredVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_APP_ID'
  ];
  // No VITE_ENCRYPTION_SECRET: the master secret is served by the authenticated
  // crypto-key endpoint after sign-in (SC-12/13). Any VITE_* variable is public —
  // this module's dynamic import.meta.env lookup inlines every one of them.
  
  const missingVars = requiredVars.filter(varName => !import.meta.env[varName]);
  
  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars.join(', '));
    
    // In production, prevent the app from running with missing variables
    if (import.meta.env.PROD) {
      throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
    }
    
    return false;
  }
  
  // Validate Firebase API key format (basic check)
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  if (apiKey && !apiKey.match(/^[A-Za-z0-9_-]+$/)) {
    console.error('Firebase API key appears to be invalid');
    
    if (import.meta.env.PROD) {
      throw new Error('Invalid Firebase API key format');
    }
    
    return false;
  }
  
  // All checks passed
  return true;
};

export default validateEnvironmentVariables;